const styles = {
    buttonWrapper: ({ spacing }) => ({
        height: spacing(3.5)
    })
};

export default styles;
